module.exports = __webpack_public_path__ + "img/inner_1_bg.66f9164f.png";